export const getEllipsisedString = (text: string, font: string, width: number) => {
  let res = text;
  const canvas = document.createElement('canvas');
  canvas.innerHTML = text;
  const context: any = canvas.getContext('2d');
  context.font = font || getComputedStyle(document.body).font;
  const textWidth = context.measureText(text).width;
  if (textWidth > width) {
    const ratio = Math.floor((text.length * width) / textWidth);
    res = text.slice(0, ratio - 5) + '...';
  }
  return res;
};
